import React, { useEffect, useState, useContext, useCallback } from 'react';
import { CircularProgress, Grid, InputLabel } from '@material-ui/core';
import { SecondaryButton, TextBox } from '../../../../Core/FormInput';
import { TechWriteScreenContext } from '../TechWriteProvider';
import AppContext from '../../../../App/AppContext';
import { PostSuggestedTextData } from '../../../../Core/Service/PartReq_services/partReq-service';
import ModalHeaderInfo from '../../../../Core/Controls/ModalHeaderInfo';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { AppStorage } from '../../../../Core/Service/storage-service';

export const SuggestedTextModal = ({ onClose }) => {
    const { state, patchSuggestedText } = useContext(TechWriteScreenContext);
    const { showToast, portalSettings } = useContext(AppContext);

    const [loader, setLoader] = useState(false);
    const [resSuggestedTextValue, setResSuggestedTextValue] = useState('');

    const fetchSuggestedText = useCallback(
        async (value) => {
            if (!value?.trim()) return;

            setLoader(true);
            try {
                const postRes = await PostSuggestedTextData({ userText: value });

                if (postRes?.success) {
                    const ResMessage = postRes.message || '';
                    const SuggestedMessage = postRes.data?.message || '';

                    ResMessage && showToast(ResMessage);
                    setResSuggestedTextValue(SuggestedMessage);
                } else {
                    showToast(postRes?.message || 'Something went wrong');
                }
            } catch (error) {
                console.error('Error fetching suggested text:', error);
                showToast('Failed to fetch suggested text');
            } finally {
                setLoader(false);
            }
        },
        [showToast]
    );

    useEffect(() => {
        if (state.suggestedTextValue) {
            fetchSuggestedText(state.suggestedTextValue);
        }
    }, [state.suggestedTextValue]);

    const handleChange = (e) => {
        setResSuggestedTextValue(e.target.value);
    };

    const copyToClipboard = (value) => {
        navigator.clipboard.writeText(AppStorage.getCanCopyUpperCaseWriteUps() ? value.toUpperCase() : value);
        showToast('Copied!');
    };

    const headerList = [
        {
            name: 'Original text',
            value: state.suggestedTextValue,
            sm: 12,
            md: 12,
            lg: 12,
            xs: 12
        }
    ];

    return (
        <div style={{ padding: '10px' }}>
            <Grid container spacing={2}>
                <Grid item xs={12} container spacing={2}>
                    <Grid item xs={12}>
                        <ModalHeaderInfo List={headerList} />
                    </Grid>

                    {loader ? (
                        <Grid
                            item
                            xs={12}
                            style={{
                                textAlign: 'center',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '200px'
                            }}
                        >
                            <CircularProgress />
                            <div>Please wait while we generate suggested text...</div>
                        </Grid>
                    ) : (
                        <Grid item xs={12}>
                            <InputLabel shrink>
                                Suggested text
                                {resSuggestedTextValue && (
                                    <FileCopyIcon
                                        style={{ fontSize: '15px', cursor: 'pointer', marginLeft: '5px', marginBottom: '-3px' }}
                                        onClick={() => copyToClipboard(resSuggestedTextValue)}
                                    />
                                )}
                            </InputLabel>
                            <TextBox
                                rows={portalSettings.portalSettingTechnWriteupHeight || 4}
                                multiline
                                value={resSuggestedTextValue}
                                onChange={handleChange}
                            />
                        </Grid>
                    )}
                </Grid>

                <Grid item xs={6}>
                    <SecondaryButton fullWidth onClick={() => patchSuggestedText(resSuggestedTextValue)} disabled={loader}>
                        Use Suggested Text
                    </SecondaryButton>
                </Grid>
                <Grid item xs={6}>
                    <SecondaryButton fullWidth onClick={onClose} disabled={loader}>
                        Cancel
                    </SecondaryButton>
                </Grid>
            </Grid>
        </div>
    );
};
